import UserTypeSelect from './UserTypeSelect';

export default UserTypeSelect;
